import { render, staticRenderFns } from "./EmitenteRegistros.vue?vue&type=template&id=87a3fce0&scoped=true"
import script from "./EmitenteRegistros.vue?vue&type=script&lang=js"
export * from "./EmitenteRegistros.vue?vue&type=script&lang=js"
import style0 from "./EmitenteRegistros.vue?vue&type=style&index=0&id=87a3fce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a3fce0",
  null
  
)

export default component.exports